import React, {useEffect} from 'react';
import styles from './Home.module.css';
import { getHomepageContent } from '../../services/contentService';
import { CustomButton, CustomFooter, CustomImage, CustomLoader, CustomTextMarkdown, CustomScrollIndicator, CustomCardInfo, CustomTitle } from '../../components';
import { ReactComponent as ArrowRightLight } from '../../assets/icons/arrow_right_light.svg';
import { ReactComponent as ArrowRightDark } from '../../assets/icons/arrow_right_dark.svg';
import { useTranslation } from 'react-i18next';
import colors from '../../styles/colors';
import { useNavigate } from 'react-router-dom';

const Home = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [pageContent, setPageContent] = React.useState<any>(null);

    useEffect(() => {
        handleGetHomepageContent();
    }, []);

    const handleGetHomepageContent = async () => {
        try {
            setIsLoading(true);

            const content = await getHomepageContent();
            setPageContent(content);

            const homeImg = new Image();
            homeImg.onload = () => setIsLoading(false);
            homeImg.src = `${process.env.REACT_APP_API_BASE_URL}${content.A_block_image.url}`;
        } catch(e) {
            console.error(e);
            throw e;
        }
    }

    return (
        <div className={ styles.container }>

            { !isLoading && pageContent &&
                <>
                    {/* block A */}
                    <div id="A_block" className={styles.A_block}>
                        <div className={styles.A_block_text}>
                            <CustomTextMarkdown className={ styles.A_block_title } components={{ p : 'h1' }}>{ pageContent.title }</CustomTextMarkdown>
                            
                            <CustomTextMarkdown className={ styles.A_block_A_paragraph }>{ pageContent.A_block_A_paragraph }</CustomTextMarkdown>
                            
                            <div className={ styles.container_A_block_B_paragraph }>
                                <CustomScrollIndicator />
                                <CustomTextMarkdown className={ styles.A_block_B_paragraph }>{ pageContent.A_block_B_paragraph }</CustomTextMarkdown>
                            </div>
                        </div>

                        <div className={ styles.container_A_block_image }>
                            <div className={ styles.A_block_image }>
                                    <CustomImage
                                        src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.A_block_image.url}`}
                                        alt=""/>
                            </div>
                        </div>
                    </div>

                    {/* block B */}
                    <div id="B_block" className={styles.B_block}>
                        <CustomTextMarkdown className={styles.B_block_title} components={{ p : 'h2'}}>{ pageContent.B_block_title }</CustomTextMarkdown>
                        <CustomTextMarkdown className={styles.B_block_paragraph}>{ pageContent.B_block_paragraph }</CustomTextMarkdown>
                        
                        <div className={styles.container_B_block_button}>
                            <CustomButton
                                buttonType="outlined"
                                color="#FFFFFF"
                                endIcon={<ArrowRightLight />}
                                onClick={() => console.log()}>
                                {t('general.learn_more')}
                            </CustomButton>
                        </div>
                    </div>

                    {/* block C */}
                    <div id="C_block" className={styles.C_block}>
                        <CustomTitle isSubtitle className={styles.C_block_subtitle}>{ pageContent.C_block_subtitle }</CustomTitle>
                        <CustomTitle className={styles.C_block_title}>{ pageContent.C_block_title }</CustomTitle>
                    
                        <div className={ styles.container_C_block_content }>
                            <div className={styles.flex_container_C_block_image}>
                                <div className={styles.C_block_image}>
                                    <CustomImage
                                        src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.C_block_image.url}`}
                                        alt=""/>
                                </div>
                            </div>

                            <div className={styles.C_block_text}>
                                <CustomTextMarkdown className={styles.C_block_paragraph}>{ pageContent.C_block_paragraph }</CustomTextMarkdown>
                                <div>
                                    <CustomButton
                                        buttonType="outlined"
                                        color={colors.darkBlue}
                                        endIcon={<ArrowRightDark />}
                                        onClick={() => navigate(`/our_story`)}>
                                        {t('general.learn_more')}
                                    </CustomButton>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* block D */}
                    <div id="D_block" className={styles.D_block}>
                        <div className={styles.container_D_block_subtitle}>
                            <CustomTitle isSubtitle className={styles.D_block_subtitle}>{ pageContent.D_block_subtitle }</CustomTitle>
                        </div>

                        <CustomTitle center className={styles.D_block_title}>{ pageContent.D_block_title }</CustomTitle>
                    
                        <div className={styles.container_D_block_cards}>
                            { pageContent.D_block_cards.map((item: any, index: number) => {
                                return (
                                    <CustomCardInfo
                                        cardType='bigIconCard'
                                        className={styles.D_block_card}
                                        key={index}
                                        title={item.title}
                                        content={item.content}
                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    {/* block E */}
                    <div id="E_block" className={styles.E_block}>
                        <div className={styles.container_E_block_title}>
                            <CustomTitle isSubtitle className={styles.E_block_subtitle}>{ pageContent.E_block_subtitle }</CustomTitle>
                            <CustomTitle className={styles.E_block_title}>{ pageContent.E_block_title }</CustomTitle>
                        </div>

                        <div className={styles.container_E_block_text}>
                            <div className={styles.flex_container_E_block_image}>
                                <div className={styles.E_block_image_container}>
                                    <CustomImage
                                        className={styles.E_block_image}
                                        src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.E_block_image.url}`}
                                        alt=""/>
                                </div>
                            </div>

                            <div className={styles.container_E_block_cards}>
                                { pageContent.E_block_cards.map((item: any, index: number) => {
                                    return (
                                        <CustomCardInfo
                                            className={styles.E_block_card}
                                            key={index}
                                            iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                            title={item.title}
                                            content={item.content}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* F block */}
                    <div id="F_block" className={styles.F_block}>

                        <CustomTitle isSubtitle className={styles.F_block_subtitle}>{ pageContent.F_block_subtitle }</CustomTitle>

                        <div className={styles.container_F_block_title}>
                            <CustomTitle className={styles.F_block_title}>{ pageContent.F_block_title }</CustomTitle>
                            <CustomTextMarkdown className={styles.F_block_paragraph}>{ pageContent.F_block_paragraph }</CustomTextMarkdown>
                        </div>

                        <div className={styles.F_block_cards_container}>
                            <div className={styles.F_block_left_card}>
                                
                                <div className={styles.F_block_card_img}>
                                    <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.F_block_cards[0]?.icon.url}`} alt="" />
                                </div>

                                <CustomTextMarkdown components={{ p : 'h4' }} className={styles.F_block_left_card_title}>{pageContent.F_block_cards[0]?.title}</CustomTextMarkdown>
                                <CustomTextMarkdown className={`${styles.F_block_left_card_paragraph} ${styles.F_block_left_card_first_p}`}>{pageContent.F_block_cards[0]?.content}</CustomTextMarkdown>
                                <CustomTextMarkdown components={{ p : 'h4' }} className={styles.F_block_left_card_subtitle}>{pageContent.F_block_cards[1]?.title}</CustomTextMarkdown>
                                <CustomTextMarkdown className={styles.F_block_left_card_paragraph}>{pageContent.F_block_cards[1]?.content}</CustomTextMarkdown>
                            </div>
                            
                            <div>
                                <div className={styles.F_block_right_cards_container}>
                                    <div className={`${styles.F_block_card} ${styles.F_block_big_card}`}>
                                        <div className={styles.F_block_card_title_container}>
                                            <CustomTextMarkdown components={{ p : 'h4' }}>{pageContent.F_block_cards[2]?.title}</CustomTextMarkdown>
                                            <div className={styles.F_block_card_icon}>
                                                <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.F_block_cards[2]?.icon.url}`} alt="" />
                                            </div>
                                        </div>

                                        <div className={styles.F_block_card_content}>
                                            <CustomTextMarkdown>{pageContent.F_block_cards[2]?.content}</CustomTextMarkdown>
                                        </div>
                                    </div>

                                    <div className={`${styles.F_block_card} ${styles.F_block_small_card}`}>
                                        <div className={styles.F_block_card_title_container}>
                                            <CustomTextMarkdown components={{ p : 'h4' }}>{pageContent.F_block_cards[3]?.title}</CustomTextMarkdown>
                                        </div>

                                        <div className={styles.F_block_card_content}>
                                            <CustomTextMarkdown>{pageContent.F_block_cards[3]?.content}</CustomTextMarkdown>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={styles.F_block_right_cards_container}>
                                    <div className={`${styles.F_block_card} ${styles.F_block_small_card}`}>
                                        <div className={styles.F_block_card_title_container}>
                                            <CustomTextMarkdown components={{ p : 'h4' }}>{pageContent.F_block_cards[4]?.title}</CustomTextMarkdown>
                                        </div>

                                        <div className={styles.F_block_card_content}>
                                            <CustomTextMarkdown>{pageContent.F_block_cards[4]?.content}</CustomTextMarkdown>
                                        </div>
                                    </div>
                                    
                                    <div className={`${styles.F_block_card} ${styles.F_block_big_card}`}>
                                        <div className={styles.F_block_card_title_container}>
                                            <CustomTextMarkdown components={{ p : 'h4' }}>{pageContent.F_block_cards[5]?.title}</CustomTextMarkdown>
                                            <div className={styles.F_block_card_icon}>
                                                <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.F_block_cards[5]?.icon.url}`} alt="" />
                                            </div>
                                        </div>

                                        <div className={styles.F_block_card_content}>
                                            <CustomTextMarkdown>{pageContent.F_block_cards[5]?.content}</CustomTextMarkdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* G block */}
                    <div className={styles.G_block}>
                        <CustomTitle isSubtitle className={styles.G_block_subtitle}>{ pageContent.G_block_subtitle }</CustomTitle>

                        <div className={styles.container_G_block_title}>
                            <CustomTitle className={styles.G_block_title}>{ pageContent.G_block_title }</CustomTitle>
                            <CustomTextMarkdown className={styles.G_block_paragraph}>{ pageContent.G_block_paragraph }</CustomTextMarkdown>
                        </div>

                        <div className={styles.G_block_cards_container}>
                            { pageContent.G_block_cards.map((item: any, index: number) => {
                                return (
                                    <CustomCardInfo
                                        className={styles.G_block_card}
                                        cardType='bigIconCard'
                                        key={index}
                                        title={item.title}
                                        content={item.content}
                                        iconUrl={`${process.env.REACT_APP_API_BASE_URL}${item.icon.url}`}
                                        btnValue={item.btnValue}
                                        btnOnClick={() => item.btnLink && navigate(item.btnLink)}
                                    />
                                    );
                                })
                            }
                        </div>
                    </div>

                    {/* footer */}
                    <CustomFooter />
                </>
            }

            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }
        </div>
    )
}

export default Home;